function toggleActiveGallerySlide(event) {
	if (dragging) return;

	var target = event.target.closest(".block.gallery .nav > a");
	if (target) {
		event.preventDefault();

		var gallery = target.closest(".block.gallery");
		gallery.querySelector(".slider .slide.active").classList.remove("active");
		gallery.querySelector(".slider .slide[data-slide='" + target.getAttribute("data-slide") + "']").classList.add("active");
	}
}

document.addEventListener("click", toggleActiveGallerySlide);
document.addEventListener("touchend", toggleActiveGallerySlide);

/**
 *	GALLERY
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll("body[data-animate-gallery] .block.gallery .image").forEach(function (el) {
		// Completely outside the viewport
        if (!isElementInViewport(el)) {
            el.classList.remove("slide");
		}
	});
})();
// Add classes when any part within viewport
var slideGalleryComponents = function () {
	document.querySelectorAll("body[data-animate-gallery] .block.gallery .image").forEach(function (el) {
		if (isElementInViewport(el)) {
			el.classList.add("slide");
		}
	});
}
window.addEventListener("scroll", slideGalleryComponents);